import PropTypes from 'prop-types';
import React from 'react';

const PulseDot = ({
  size = 14,
  color = '#4397fa',
  pulseColor,
  pulseDuration = 1, // seconds for one pulse
  className = '',
  style = {},
  ...props
}) => {
  const dotSize = typeof size === 'number' ? `${size}px` : size;
  const pulseSize =
    typeof size === 'number'
      ? `${Number(size) * 1.5}px`
      : `calc(${size} * 1.5)`;
  const _pulseColor = pulseColor || color;

  return (
    <span
      className={`pulse-dot-wrapper ${className}`}
      style={{
        display: 'inline-block',
        position: 'relative',
        width: pulseSize,
        height: pulseSize,
        ...style,
      }}
      {...props}
    >
      <span
        className="pulse-dot-pulse"
        style={{
          position: 'absolute',
          left: `50%`,
          top: `50%`,
          width: pulseSize,
          height: pulseSize,
          marginLeft: `calc(-1 * (${pulseSize} / 2))`,
          marginTop: `calc(-1 * (${pulseSize} / 2))`,
          background: _pulseColor,
          opacity: 0.23,
          borderRadius: '50%',
          zIndex: 0,
          animation: `pulse-dot-animation ${pulseDuration}s cubic-bezier(0.54, 0, 0.57, 1) infinite`,
        }}
      />
      <span
        className="pulse-dot-core"
        style={{
          display: 'block',
          position: 'absolute',
          left: '50%',
          top: '50%',
          width: dotSize,
          height: dotSize,
          background: color,
          borderRadius: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 2,
          boxShadow: '0 0 0 1px rgba(0,0,0,0.04)',
        }}
      />
      <style>{`
        @keyframes pulse-dot-animation {
          0% {
            transform: scale(0.5);
            opacity: 0.30;
          }
          10% {
            transform: scale(0.7);
            opacity: 0.26;
          }
          20% {
            transform: scale(0.85);
            opacity: 0.23;
          }
          30% {
            transform: scale(1.0);
            opacity: 0.19;
          }
          40% {
            transform: scale(1.15);
            opacity: 0.17;
          }
          50% {
            transform: scale(1.23);
            opacity: 0.13;
          }
          60% {
            transform: scale(1.33);
            opacity: 0.10;
          }
          70% {
            transform: scale(1.43);
            opacity: 0.08;
          }
          80% {
            transform: scale(1.55);
            opacity: 0.04;
          }
          90% {
            transform: scale(1.68);
            opacity: 0.02;
          }
          100% {
            transform: scale(1.8);
            opacity: 0;
          }
        }
      `}</style>
    </span>
  );
};

PulseDot.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string,
  pulseColor: PropTypes.string,
  pulseDuration: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default PulseDot;
